import type { PatternFormFieldItemConstant } from '@ricoh/ria.client.core/types/component/pattern.type';
import type { Except } from 'type-fest';

import { ClientError } from '@ricoh/ria.client.core/errors';
import { isType } from '@ricoh/ria.client.core/utils/data/object';

import type { FieldDataSourceAI } from '~/common/model/api/batch-type';

import type { FieldDataSourceFormFieldAI } from './_data-source.type';

/**
 * Create Field DataSource AI Value FormFieldItem.
 *
 * @param {FieldDataSourceAI} dataSource DataSource AI.
 *
 * @returns {FieldDataSourceFormFieldAI['value']} Field DataSource AI Value FormFieldItem.
 */
export function createFieldDataSourceAIValueFormField(dataSource: FieldDataSourceAI): FieldDataSourceFormFieldAI['value'] {
  return [
    {
      $is: 'tag',
      tabKey: dataSource.type,
      value: dataSource.name,
    },
  ];
}

/**
 * Create Field DataSource AI Value from FormFieldItem.
 *
 * @param {NonNullable<FieldDataSourceFormFieldAI['value']>} dataSourceValue Field DataSource FormFieldItem AI Value.
 *
 * @returns {Except<FieldDataSourceAI, '$is'>} Field DataSource AI Value.
 */
export function createFieldDataSourceAIValue(dataSourceValue: NonNullable<FieldDataSourceFormFieldAI['value']>): Except<FieldDataSourceAI, '$is'> {
  const [item] = dataSourceValue;
  if (!item || isType<PatternFormFieldItemConstant>(item, 'const')) {
    throw new ClientError({
      module: 'logic',
      message: 'Invalid DataSource AI value',
      cause: { dataSourceValue },
    });
  }

  return {
    type: item.tabKey,
    name: item.value.toString(),
  };
}
